import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Modal,
  TableContainer,
  Box,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  Grid,
  TextField,
  Autocomplete,
  Paper,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import moment from "moment";
import { useNavigate } from "react-router";

const SrfAudit = ({ open, onClose, row }) => {
  const navigate = useNavigate();
  const [certificates, setCertificates] = useState([]);
  const [userList, setuserList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  function getCertificates() {
    const url = `${BASE_URL}dynamic`;
    const Payload = {
      query: `SELECT * FROM certificatesView WHERE serviceReqNumber = '${row?.serviceReqNumber}';`,
    };
    axiosWithToken
      .post(url, Payload)
      .then((res) => setCertificates(res.data || []))
      .catch((err) => console.log("Error fetching certificates:", err));
  }
  function getUserList() {
    const url = `${BASE_URL}dynamic`;
    // const idList = ids.join(",");
    const Payload = {
      query: `SELECT * FROM users;`,
    };
    axiosWithToken
      .post(url, Payload)
      .then((res) => {
        setuserList(res.data || []);
      })
      .catch((err) => console.log("Error fetching userlist:", err));
  }

  useEffect(() => {
    if (open && row?.id) {
      getCertificates();
    }
    getUserList();
  }, [open, row]);

  // Create userId => username map
  const userMap = userList.reduce((acc, user) => {
    acc[user.id] = user.userName;
    return acc;
  }, {});

  const handleauditNavigate = (item) => {
    const auditIdArray = JSON.stringify([item.id]);
      // Store extra data in sessionStorage
      sessionStorage.setItem("auditExtraData", JSON.stringify({
        customerName: row.customerName,
        serviceReqNumber: row.serviceReqNumber,
        ducid: item.DUCID,
        serialNumber: item.serialNumber,
      }));
      
    window.open(
      `/#/auditlogview?id=${encodeURIComponent(auditIdArray)}`,
      "_blank"
    );
  };

  return (
    <Modal open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          width: 1100,
          height: 550,
          overflowY: "scroll",
        }}
      >
        <Button
          variant="contained"
          size="small"
          style={{ float: "right" }}
          onClick={() => onClose()}
        >
          X
        </Button>
        <Box>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    border: "none",
                    fontWeight: "bold",
                    fontSize: "20px",
                    padding: 0,
                    width: "200px",
                  }}
                >
                  Client:
                </TableCell>
                <TableCell
                  style={{ border: "none", fontSize: "18px", padding: 0 }}
                >
                  {row?.customerName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    border: "none",
                    fontWeight: "bold",
                    fontSize: "20px",
                    padding: 0,
                  }}
                >
                  SRF Number:
                </TableCell>
                <TableCell
                  style={{ border: "none", fontSize: "18px", padding: 0 }}
                >
                  {row?.serviceReqNumber}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    border: "none",
                    fontWeight: "bold",
                    fontSize: "20px",
                    padding: 0,
                  }}
                >
                  Total Instruments:
                </TableCell>
                <TableCell
                  style={{ border: "none", fontSize: "18px", padding: 0 }}
                >
                  {certificates.length}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Sr.No
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Instrument Name
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  DUCID
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Serial Number
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Inward Date
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                 DUC_Details (Created By)
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Calibrated By
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Calibration Date
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Approved By
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Approved Date
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    backgroundColor: "#1976d2",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {certificates
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell style={{ fontSize: "12px" }}>
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {item?.instrumentName || item?.requestedDucName}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {item?.DUCID}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {item?.serialNumber}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {item?.entryDate
                        ? moment(item?.entryDate).format("DD-MM-YYYY")
                        : ""}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {userMap[item?.createdby] || ""}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {userMap[item?.calibratedby] || ""}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {item?.calibrationDate
                        ? moment(item?.calibrationDate).format(
                            "DD-MM-YYYY, hh:mm A"
                          )
                        : ""}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {userMap[item?.approvedby] || ""}
                    </TableCell>
                    <TableCell style={{ fontSize: "12px" }}>
                      {item?.approvedDate
                        ? moment(item?.approvedDate).format(
                            "DD-MM-YYYY, hh:mm A"
                          )
                        : ""}
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => handleauditNavigate(item)}
                        size="small"
                        variant="text"
                      >
                        View Audit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 30, 50]}
          component="div"
          count={certificates.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </Box>
    </Modal>
  );
};

export default SrfAudit;
